// extracted by mini-css-extract-plugin
module.exports = {"ModalDecline":"ModalDecline_ModalDecline__2nWK0","botonera":"ModalDecline_botonera__3CChk","TableDecline":"ModalDecline_TableDecline__16swh"};